module.exports = __webpack_public_path__ + "static/007412-b15afbf17607d566cffcfc1473c9b11d.jpg";